import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import { getGameSettingsRaw } from '@sportninja/common/services/game/timelineServices'
import type { GameSettings } from '@sportninja/common/types/GameSettings'

/**
 * Game-level scoring/context settings (waiver + jersey rules) for the attendance
 * modal. Wraps the shared scoringContextSettings query key.
 *
 * The `/games/{id}/settings` endpoint returns the settings payload directly
 * (`{ id, settings: { game: {...} } }`) — NOT wrapped in a `{ data, meta }`
 * envelope. So the game settings live at `query.data.settings.game`, matching
 * the mobile attendance access pattern (`settings?.settings?.game?...`).
 */
export const useScoringContextSettings = (gameId?: string) => {
  const query = useQuery({
    queryKey: queryKeys.scoringContextSettings.byGame(gameId),
    queryFn: () =>
      getGameSettingsRaw(gameId as string) as Promise<GameSettings>,
    enabled: Boolean(gameId),
  })

  const game = query.data?.settings?.game
  return {
    requireWaiverSignature: !!game?.require_waiver_signature,
    requireUniqueJerseyNumbers: !!game?.require_unique_jersey_numbers,
  }
}
